export interface NavLink {
  label: string;
  href: string;
  tKey: string;
}

export interface NavDropdown {
  label: string;
  tKey: string;
  items: NavLink[];
}

export type NavItem = NavLink | NavDropdown;

export function isDropdown(item: NavItem): item is NavDropdown {
  return 'items' in item;
}

// `label` is the English fallback; `tKey` resolves to Nav.<tKey> in the message
// catalogs (src/messages/*.json) so the nav follows the selected site language.
export const navItems: NavItem[] = [
  {
    label: 'Our Cabins',
    tKey: 'ourCabins',
    items: [
      { label: 'All Cabins', href: '/cabins', tKey: 'allCabins' },
      { label: 'Cabins in Levi', href: '/levi', tKey: 'cabinsLevi' },
      { label: 'Cabins in Ylläs', href: '/yllas', tKey: 'cabinsYllas' },
      { label: 'PikuPoikka', href: '/cabins/pikupoikka', tKey: 'pikupoikka' },
      { label: 'IsoPoikka', href: '/cabins/isopoikka', tKey: 'isopoikka' },
      { label: 'Iso-Ylläs', href: '/cabins/iso-yllas', tKey: 'isoYllas' },
      { label: 'Mestari', href: '/cabins/mestari', tKey: 'mestari' },
      { label: 'Compare Cabins', href: '/cabins/compare', tKey: 'compareCabins' },
    ],
  },
  { label: 'Reviews', href: '/reviews', tKey: 'reviews' },
  {
    label: 'Things to Do',
    tKey: 'thingsToDo',
    items: [
      { label: 'All Activities', href: '/things-to-do', tKey: 'allActivities' },
      { label: 'Northern Lights', href: '/activities/northern-lights', tKey: 'northernLights' },
      { label: 'Skiing & Snowboarding', href: '/activities/skiing', tKey: 'skiing' },
      { label: 'Cross-Country Skiing', href: '/activities/cross-country-skiing', tKey: 'crossCountry' },
      { label: 'Husky Safaris', href: '/activities/husky-safaris', tKey: 'huskySafaris' },
      { label: 'Snowmobile Safaris', href: '/activities/snowmobile-safaris', tKey: 'snowmobileSafaris' },
      { label: 'Reindeer Experiences', href: '/activities/reindeer-experiences', tKey: 'reindeer' },
      { label: 'Snowshoeing', href: '/activities/snowshoeing', tKey: 'snowshoeing' },
      { label: 'Ice Karting', href: '/activities/ice-karting', tKey: 'iceKarting' },
      { label: 'Finnish Sauna', href: '/activities/sauna', tKey: 'sauna' },
    ],
  },
  {
    label: 'Useful Tools',
    tKey: 'usefulTools',
    items: [
      { label: 'Weather & Snow', href: '/weather', tKey: 'weather' },
      { label: 'Aurora Forecast', href: '/aurora', tKey: 'aurora' },
      { label: 'Road Conditions', href: '/road-conditions', tKey: 'roadConditions' },
      { label: 'Culture & Tips', href: '/culture', tKey: 'culture' },
      { label: 'Getting Here', href: '/getting-here', tKey: 'gettingHere' },
    ],
  },
  { label: 'Property Services', href: '/property-services', tKey: 'propertyServices' },
  { label: 'Blog', href: '/blog', tKey: 'blog' },
];
